import { render } from "./MyBoxesModal.vue?vue&type=template&id=0bf72456"
import script from "./MyBoxesModal.vue?vue&type=script&lang=js"
export * from "./MyBoxesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__